export default "__VITE_ASSET__CNKogfED__"